const EmailIcon = ({ color = '#7a7a7a', size = 20 }: { color?: string; size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.5 12.5787C17.5 14.883 15.9627 16.756 13.6819 16.7503H6.31811C4.0373 16.756 2.5 14.883 2.5 12.5787V7.42764C2.5 5.12574 4.0373 3.25034 6.31811 3.25034H13.6819C15.9627 3.25034 17.5 5.12574 17.5 7.42764V12.5787Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.4205 7.42514L11.088 10.1348C10.4605 10.6335 9.57104 10.6335 8.94346 10.1348L5.58264 7.42514"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.30218 9.61835L5.57947 12.5753M14.4214 12.5758L11.7286 9.61876"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default EmailIcon;
